import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=2c0b0c68"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0b0c68')) {
      api.createRecord('2c0b0c68', component.options)
    } else {
      api.reload('2c0b0c68', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=2c0b0c68", function () {
      api.rerender('2c0b0c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/notifications/Notification.vue"
export default component.exports